var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 114,
    viewBox: "0 0 118 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6153 81.207V94.8444H47.6582C37.5715 94.8444 29.3888 102.97 29.3888 113V113.5H29.8888H88.1123H88.6123V113C88.6123 102.97 80.4299 94.8444 70.3428 94.8444H68.3847V81.207C79.9507 78.1786 89.2669 69.7172 93.4216 58.7137C107.279 54.8918 117.5 42.2791 117.5 27.3016V19.2799C117.5 14.4963 113.586 10.6115 108.779 10.6115H95.795V1V0.5H95.295H22.705H22.205V1V10.6115H9.22095C4.41439 10.6115 0.5 14.4963 0.5 19.2799V27.3016C0.5 42.2791 10.7208 54.8918 24.5785 58.7137C28.7331 69.7172 38.0493 78.1786 49.6153 81.207ZM68.2035 40.4223L70.3205 52.6862L59.2315 46.8937L59 46.7728L58.7685 46.8937L47.6795 52.6862L49.7965 40.4223L49.8415 40.1619L49.6517 39.9781L40.687 31.2957L53.0787 29.5064L53.3384 29.4689L53.4551 29.2339L59 18.071L64.5449 29.2339L64.6616 29.4689L64.9213 29.5064L77.3131 31.2957L68.3484 39.9781L68.1586 40.1619L68.2035 40.4223ZM10.3847 27.3016V20.4393H22.205V45.8905C22.205 46.3215 22.2282 46.7513 22.2557 47.1709C15.1987 43.2769 10.3847 35.8623 10.3847 27.3016ZM107.615 27.3016C107.615 35.8623 102.801 43.2769 95.7443 47.1709C95.7718 46.7513 95.795 46.3215 95.795 45.8904V20.4393H107.615L107.615 27.3016Z",
    fill: "#FFD80D",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.e2b693c07b7326dcab7873c600963301.svg";
export { ForwardRef as ReactComponent };